<template>
  <div class="activestatistics">
    <div class="header">
      <label>考试类型：</label>
      <el-checkbox-group v-model="params.type">
        <el-checkbox v-for="item in trainingstate" :label="item.value">{{ item.label }}</el-checkbox>
      </el-checkbox-group>
      <el-input v-model="params.searchValue" clearable placeholder="请输入试卷标题" style="width: 200px;margin:0 30px"></el-input>
      <el-button type="primary" @click="clicksearch">{{ $t('Education.languages01') }}</el-button>
      <el-button type="primary" @click="ClickExport">{{ $t('Education.languages20') }}</el-button>
    </div>

    <div class="content">
      <el-table
          :data="Examstatistics"
          v-loading="loading"
          :cell-style="{'text-align':'center'}"
          style="width: 100%">
        <el-table-column type="index" label="序号" width="50">
          <template slot-scope="scope" center>
                {{ (params.pageNum - 1) * 10 + scope.$index + 1 }}
              </template>
        </el-table-column>
        <el-table-column prop="examTitle" label="试卷标题"></el-table-column>
        <el-table-column prop="examType" label="考试类型"></el-table-column>
        <el-table-column prop="usesNum" label="使用次数"> </el-table-column>
        <el-table-column prop="attendNum" label="参考总人数"> </el-table-column>
        <el-table-column prop="examPassScore" label="合格分数"> </el-table-column>  
        <el-table-column label="占比/通过人数">
          <template v-slot="scope">
             <el-col :span="18" >
               <el-progress
                    text-color="red"
                   :text-inside="true"
                   :stroke-width="20"
                   :color="stydycolor"
                   :percentage="scope.row.passNumProportion"></el-progress>
             </el-col>
            <el-col :span="4" :offset="1">{{ scope.row.passNum }}</el-col>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
      style="margin-top: 20px;"
      hide-on-single-page
      @current-change="handleCurrentChange"
      :current-page.sync="params.pageNum"
      :page-size="params.pageSize"
      layout="total, prev, pager, next"
      :total="params.Total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default ({
  name:'activestatistics',
  data(){
    return{
      params:{
        pageNum:1,
        pageSize:10,
        Total:0,
        type:[],
        searchValue:''
      },
      loading:true,
      trainingstate:[
        {value:"1",label: '培训考试'}, 
        {value:"2",label: '课程考试'}, 
        {value:"3",label: '章节考试'}
      ],
      Examstatistics:[],
      stydycolor:[
        {color: '#f56c6c', percentage: 20},
        {color: '#ffb444', percentage: 40},
        {color: '#f19b59', percentage: 60},
        {color: '#1989fa', percentage: 80},
        {color: '#3ea660', percentage: 100}
      ]
    }
  },
  created() {
    this.getExamStatistics();
  },
  methods:{
    getExamStatistics(){
      this.loading=true;
      this.$Http_Post('edu/examRecord/getExamStatistics',this.params).then(res=>{
        if(res.Code==0 || res.Code==200){
          this.Examstatistics=res.Data;
          this.params.Total=res.Counts;
        }else{
          this.$message({type: 'error', message:res.Message});
        }
        this.loading=false;
      });
    },
    handleCurrentChange(val){
      this.params.pageNum=val;
      this.getExamStatistics();
    },
    clicksearch(){
      this.params.pageNum=1;
      this.getExamStatistics();
    },
    ClickExport(){
      let typedata='';
      if(this.params.type.length==0){
        location.href=process.env.VUE_APP_URL+'edu/examRecord/exportExamStatistics?searchValue='+this.params.searchValue;
      }else{
        for(var i=0;i<=this.params.type.length;i++){
          if(i<this.params.type.length){
            typedata+='&type='+this.params.type[i];
          }else{
            location.href=process.env.VUE_APP_URL+'edu/examRecord/exportExamStatistics?searchValue='+this.params.searchValue+typedata;
          }
        }
      }
    }
  },
})
</script>
<style>
.activestatistics .el-checkbox{margin-right: 10px;}
.activestatistics .header{display: flex;align-items:center;background: #fff;padding:20px 30px;;}
.activestatistics .content{background:#fff;padding:30px;margin-top:20px;}
.activestatistics .Proportion{padding:0 30px;}
.activestatistics .Proportion span{background:#78bbff;color: #fff;display: inline-block;text-align: center;width: 50%;border-radius: 20px 0 0 20px;}
.activestatistics .Proportion label{display: inline-block;text-align: center;width: 50%;border-radius:0 20px 20px 0;background:#ffd3a5;color: #fff;}
.activestatistics .el-progress-bar__innerText{color: #000;}
</style>